import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  DataMigration,
  ProfitMargin,
  Reminder,
  ResetAccount,
  ShiftSettings,
  SmsSetup,
} from '@C/Settings/RouteComponents';

const RouteSetup = () => {
  const env = process.env.ENVIRONMENT;
  return (
    <Switch>
      {env === 'development' && (
        <Route path="/settings/reminder-notifications" component={Reminder} />
      )}
      <Route path="/settings/sms" component={SmsSetup} />
      <Route path="/settings/reset-account" component={ResetAccount} />
      <Route path="/settings/profit-margin" component={ProfitMargin} />
      <Route path="/settings/shift-settings" component={ShiftSettings} />
      <Route path="/settings/data-migration" component={DataMigration} />
      <Route path="/settings/bunk-config">
        <Redirect to="/settings/shift-settings" />
      </Route>
      <Route path="/settings">
        <Redirect to={`/settings/sms`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
